import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetSupervisor } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiUrl2 + 'config-spv-list';
    if(page === undefined){
        page = 1;
    }

    var query = {
        "search":"",
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"ASC",
    };

    if(search != null){
        search.map((v,k)=>{ 
            if(v !== ""){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        "query": query
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
    }

    dispatch({ type: GetSupervisor, data: fromJS(data) });
};